import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'brand_acquisition-brandinboundapplication-action_unknown';
/**
 * Emits facebook event when a brand completes registration
 */
export function trackBrandAcquisitionBrandinboundapplication(pixelCustomDataParams) {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
        facebookPixelEvent: 'BrandInboundApp',
        pixelCustomDataParams: pixelCustomDataParams,
    });
}
